'use strict';
import noop from 'lodash/noop';
import formsCreateTemplate from './controllers/create.html';
import formsTemplate from './controllers/list.html';


export const formsStates = {
  forms: 'app.forms',
  formsCreate: 'app.forms-create',
  formsEditor: 'app.forms-editor',
};

routerConfig.$inject = [
  '$stateProvider',
];

export function routerConfig(
  $stateProvider,
) {
  $stateProvider
    .state(formsStates.forms, {
      title: 'forms.views.list.header.label',
      url: '/forms',
      views: {
        'appContent': {
          template: formsTemplate,
          controller: 'FormListController',
        },
      },
    })

    .state(formsStates.formsCreate, {
      title: 'forms.views.create.header.label',
      url: '/forms/create',
      views: {
        'appContent': {
          template: formsCreateTemplate,
          controller: 'FormCreateController',
        },
      },
      resolve: {
        form: noop,
      },
    })

    .state(formsStates.formsEditor, {
      title: 'forms.views.update.header.label',
      url: '/forms/editor/:formId',
      views: {
        'appContent': {
          template: formsCreateTemplate,
          controller: 'FormCreateController',
        },
      },
      resolve: {
        form: ['$stateParams', 'FormDomain', 'currentUser', resolveForm],
      },
    });

  function resolveForm($stateParams, FormDomain) {
    if ($stateParams.formId) {
      return FormDomain.$get($stateParams.formId);
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/forms/router.js